/**
 * Tipos compartilhados de permissões
 *
 * Extraído de usePermissionCheck.ts para evitar dependência circular
 * entre hooks/usePermissionCheck ↔ lib/permissions/unifiedPermissionService.
 */

export type PermissionStatus =
  | 'allowed'           // Permitido (flag = true ou é admin)
  | 'denied'            // Bloqueado (flag = false explicitamente)
  | 'not_configured'    // Bloqueado (flag não existe no banco)
  | 'admin_only';       // Bloqueado (apenas admin)

export interface PermissionResult {
  allowed: boolean;
  status: PermissionStatus;
  reason?: string;
}

/**
 * Mensagens amigáveis para cada status de permissão
 */
export const PERMISSION_MESSAGES: Record<PermissionStatus, string> = {
  allowed: 'Acesso permitido',
  denied: 'Você não tem permissão para acessar este recurso.',
  not_configured: 'Este recurso ainda não está configurado para seu perfil. Entre em contato com o administrador.',
  admin_only: 'Este recurso está disponível apenas para administradores.',
};
